// Warn banner shown in the TenantCreateForm when a 201 carries
// X-Vault-Sync: error. The DB row exists; the Vault dual-write did
// not. The tenant detail page is the next stop for repair.

import { Link } from "@tanstack/react-router";

import { Pill } from "../../components/ui/Pill";
import type { TenantOut } from "../../api/types/tenant";

interface VaultSyncBannerProps {
  tenant: TenantOut;
}

export function VaultSyncBanner({ tenant }: VaultSyncBannerProps) {
  return (
    <div
      style={{
        border: "1px solid var(--warn)",
        background: "rgba(251, 191, 36, 0.08)",
        borderRadius: 6,
        padding: "10px 12px",
        fontSize: "0.85rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
        <Pill tone="warn">Vault dual-write failed</Pill>
        <strong>Tenant created in DB; Vault sync still pending</strong>
      </div>
      <div style={{ color: "var(--text)" }}>
        {tenant.vault_sync_last_error ?? "Vault write did not succeed."}
      </div>
      <div style={{ marginTop: 8 }}>
        <Link
          to="/accounts/$accountSlug/tenants/$tenantSlug"
          params={{ accountSlug: tenant.account_slug, tenantSlug: tenant.slug }}
          style={{
            color: "var(--accent)",
            fontSize: "0.85rem",
          }}
        >
          Go to tenant detail →
        </Link>
      </div>
    </div>
  );
}
